"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableFips = void 0;
const crypto_1 = __importDefault(require("crypto"));
const enableFips = (fips, ignoreError = false) => {
    try {
        // FIX-ME The mark command is calling tag.execute function, and when doing so, the fips option
        // is not reduced to a boolean, but remains a clipanion option, mistakenly enabling fips.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-boolean-literal-compare
        if (fips === true) {
            crypto_1.default.setFips(true);
        }
    }
    catch (error) {
        if (!ignoreError) {
            throw error;
        }
    }
};
exports.enableFips = enableFips;
//# sourceMappingURL=fips.js.map